export const COMPONENT_RELIABILITY = 'Component Reliability';
export const SSI_MSI_TASKS = 'List of Transferred SSI/MSI Tasks';
